export function replace(input: string, re: RegExp, replacer: any) {
  let match
  let remaining = input
  let rewritten = ''
  while ((match = re.exec(remaining))) {
    rewritten += remaining.slice(0, match.index)
    rewritten += replacer(match)
    remaining = remaining.slice(match.index + match[0].length)
  }
  rewritten += remaining
  return rewritten
}

export function replaceContent(str: string, replacer: (arg: string) => any) {
  let contentStr = ''
  const prefixTagStr = (tagStr: string) => {
    if (contentStr) {
      const prefix = contentStr
      contentStr = ''
      return `${replacer(prefix)}${tagStr}`
    }
    return tagStr
  }
  // 正则优先级：a标签 -> 任意标签 -> 任意内容(任意内容一次只匹配一个)
  const replacedStr = replace(
    str,
    /(<a(?:\s[^>]+)?>.*?<\/a>)|(<([a-z]\w*)(?:\s[^>]+)?>.*<\/\3>)|(.)/i,
    (match: any[]) => {
      if (match[1]) {
        // a标签直接返回
        return prefixTagStr(match[1])
      } else if (match[2]) {
        // 普通标签进行二次匹配
        return replace(
          match[2],
          /(<([a-z]\w*)(?:\s[^>]+)?>)(.*)(<\/\2>)(.*)/i,
          (match: any[]) => {
            return prefixTagStr(
              `${match[1]}${replaceContent(match[3], replacer)}${match[4]}`
            )
          }
        )
      } else {
        // 内容进行追加获取完整字符串
        contentStr += match[4]
        return ''
      }
    }
  )
  return `${replacedStr}${replacer(contentStr)}`
}
